<span class="rex-tutorial-go-to-step-button__indicator"></span>
<span class="rex-tutorial-go-to-step-button__content">
  <p style="width: 180px;">
    <ng-content></ng-content>
  </p>
</span>
